/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LifeCycleStage } from './LifeCycleStage';
import {
	LifeCycleStageFromJSON,
	LifeCycleStageFromJSONTyped,
	LifeCycleStageToJSON,
} from './LifeCycleStage';

/**
 *
 * @export
 * @interface CreateServiceTeamResponse
 */
export interface CreateServiceTeamResponse {
	/**
	 * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
	 *
	 * @type {string}
	 * @memberof CreateServiceTeamResponse
	 */
	rID: string;
	/**
	 *
	 * @type {LifeCycleStage}
	 * @memberof CreateServiceTeamResponse
	 */
	stage: LifeCycleStage;
}

/**
 * Check if a given object implements the CreateServiceTeamResponse interface.
 */
export function instanceOfCreateServiceTeamResponse(value: object): boolean {
	let isInstance = true;
	isInstance = isInstance && 'rID' in value;
	isInstance = isInstance && 'stage' in value;

	return isInstance;
}

export function CreateServiceTeamResponseFromJSON(json: any): CreateServiceTeamResponse {
	return CreateServiceTeamResponseFromJSONTyped(json, false);
}

export function CreateServiceTeamResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): CreateServiceTeamResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		rID: json['RID'],
		stage: LifeCycleStageFromJSON(json['stage']),
	};
}

export function CreateServiceTeamResponseToJSON(
	value?: CreateServiceTeamResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		RID: value.rID,
		stage: LifeCycleStageToJSON(value.stage),
	};
}
